<template>
  <div>{{ valueMutable }}</div>
</template>
<script>

export default {
  name: 'criteriaActivatorDefault',
  computed: {
    valueMutable: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('update:value', newValue)
      }
    }
  },
  props: {
    dataQa: {
      type: String,
      default: 'default-value'
    },
    items: {
      type: Array
    },
    value: {
      type: String
    }
  },
}
</script>
